import { render, staticRenderFns } from "./Players.vue?vue&type=template&id=0f773800&scoped=true"
import script from "./Players.js?vue&type=script&lang=js&external"
export * from "./Players.js?vue&type=script&lang=js&external"
import style0 from "./Players.vue?vue&type=style&index=0&id=0f773800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f773800",
  null
  
)

export default component.exports